import React, { useState } from 'react';
import { Search, Users, Calendar, FileText, Edit, Eye, ChevronDown } from 'lucide-react';
import useGroupProjectManagementStore from '@/stores/AdminStore/GroupProjectManagementStore';
import './ProjectList.css';

const ProjectList = () => {
  const { projects } = useGroupProjectManagementStore();

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('all');

  const filteredProjects = projects?.filter(project => {
    const matchesSearch = project.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         project.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = selectedStatus === 'all' || project.status === selectedStatus;
    return matchesSearch && matchesStatus;
  }) || [];

  return (
    <div className="trainer-group-project-list-container">
      <div className="trainer-group-project-list-wrapper">
        {/* Search and Filter Section */}
        <div className="trainer-group-project-filters">
          <div className="trainer-group-search-box">
            <Search size={20} className="trainer-group-search-icon" />
            <input
              type="text"
              placeholder="Search Projects"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="trainer-group-search-input"
            />
          </div>

          <div className="trainer-group-filter-dropdown">
            <select
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              className="trainer-group-status-select"
            >
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="draft">Draft</option>
              <option value="completed">Completed</option>
            </select>
            <ChevronDown size={20} className="trainer-group-dropdown-icon" />
          </div>
        </div>

        {/* Projects Grid */}
        <div className="trainer-group-projects-grid">
          {filteredProjects.map((project) => (
            <div key={project.id} className="trainer-group-project-card">
              {/* Header with Icon and Status */}
              <div className="trainer-group-project-card-header">
                <div className="trainer-group-project-icon">
                  <Users size={28} />
                </div>
                <span className={`trainer-group-status-badge trainer-group-status-${project.status}`}>
                  {project.status}
                </span>
              </div>

              {/* Project Title and Description */}
              <div className="trainer-group-project-content">
                <h3 className="trainer-group-project-title">{project.name}</h3>
                <p className="trainer-group-project-description">{project.description}</p>
              </div>

              {/* Project Details */}
              <div className="trainer-group-project-details">
                <div className="trainer-group-detail-item">
                  <Calendar size={16} className="trainer-group-detail-icon" />
                  <span>Due {project.deadline}</span>
                </div>
                <div className="trainer-group-detail-item">
                  <Users size={16} className="trainer-group-detail-icon" />
                  <span>{project.teams} teams • {project.membersPerTeam} members each</span>
                </div>
                <div className="trainer-group-detail-item">
                  <FileText size={16} className="trainer-group-detail-icon" />
                  <span>{project.deliverables} deliverables</span>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="trainer-group-project-actions">
                <button className="trainer-group-btn trainer-group-btn-view">
                  <Eye size={16} />
                  View
                </button>
                <button className="trainer-group-btn trainer-group-btn-edit">
                  <Edit size={16} />
                  Edit
                </button>
              </div>

              {/* Footer */}
              <div className="trainer-group-project-footer">
                Created {project.created}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectList;